import React  from 'react';
import PropTypes from 'prop-types';

const LanguageTab = (props) => (<div>
        <div className={'countryFlag'}>
            <span className={`flagIcon  ${props.value}`}></span>
            <span>{props.label}</span>
        </div>
    </div>);

LanguageTab.propTypes = {
    label: PropTypes.string,
    customAbbreviation: PropTypes.string,
    value: PropTypes.string
};

export default LanguageTab;
